import '@/styles/style.css';

import ui from '@nuxt/ui/vue-plugin';
import { createPinia } from 'pinia';
import type { Plugin } from 'vue';
import { createApp } from 'vue';

import { setupValibotI18n } from '@hive/core';

import App from '@/App.vue';
import { apolloClient } from '@/core/apollo/client';
import router from '@/core/router';

setupValibotI18n();

import * as plugins from '@/core/plugins';
import * as ApolloComposable from '@vue/apollo-composable';

import { registerModules } from '@/core/register-modules.ts';

import { AuthModule } from '@/modules/auth';
import { JobsModule } from '@/modules/jobs';
import { ProjectsModule } from '@/modules/projects';
import { SandboxModule } from './modules/sandbox';
import { UsersModule } from './modules/users';

registerModules({
  AuthModule,
  JobsModule,
  ProjectsModule,
  SandboxModule,
  UsersModule,
});

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.use(ui);
app.provide(ApolloComposable.ApolloClients, {
  default: apolloClient,
});

for (const plugin of Object.values(plugins) as Plugin[]) {
  app.use(plugin);
}

router.isReady().then(() => {
  app.mount('#app');
});
